import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "audit-modal"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "grid-title"
}, "审核人信息（请确认审核人角色具有订单审核菜单查看权限）", -1);

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 添加 ");

const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 删除 ");

const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "grid-title"
}, "被审核人信息", -1);

const _hoisted_6 = /*#__PURE__*/_createTextVNode("添加");

const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 删除 ");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("确认");

import { computed, ref, watch } from 'vue';
import { arrayRemoveRepeatByProp } from '@/utils';
import { createOrderauditMain, getPersonnelReview, updateOrderauditMain } from '@/request';
import { ElMessage } from 'element-plus';
import { useRoute } from 'vue-router';
import AddSalesmanModal from './AddSalesmanModal.vue';
export default {
  name: 'AddPersonAuditModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    auditMainId: {
      type: [null, Number],
      default: null
    },
    supplierId: [String, Number],
    auditParams: Object
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const route = useRoute(); // const supplierId = route.query.supplierId;

    const supplierId = ref(props.supplierId).value;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const reviewer = ref(1);
    const showAddSalesmanModal = ref(false);
    const auditTableData = ref([]);
    const auditTable = ref();
    const auditTableOptions = {
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        title: '登录账号',
        field: 'loginName',
        width: '150px',
        showOverflow: true
      }, {
        title: '联系人',
        field: 'linkMan',
        width: '150px',
        showOverflow: true
      }, {
        title: '角色名称',
        field: 'businessCategory',
        width: '150px',
        showOverflow: true
      }, // {
      //   title: '维护站点',
      //   field: 'salesmanBranchNameCover',
      //   width: '150px',
      //   showOverflow: true
      // }
      {
        title: '团队',
        field: 'supplierName',
        width: '150px',
        showOverflow: true
      }]
    };
    const auditeeTable = ref();
    const auditeeTableData = ref([]);
    const auditeeTableOptions = {
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        title: '登录账号',
        field: 'loginName',
        width: '150px',
        showOverflow: true
      }, {
        title: '联系人',
        field: 'linkMan',
        width: '150px',
        showOverflow: true
      }, {
        title: '角色名称',
        field: 'businessCategory',
        width: '150px',
        showOverflow: true
      }, {
        title: '团队',
        field: 'supplierName',
        width: '150px',
        showOverflow: true
      }]
    };

    function initUpdateData(type) {
      // 初始化需要修改的信息
      getPersonnelReview(_objectSpread({
        auditMainId: props.auditMainId,
        type
      }, props.auditParams)).then(data => {
        if (data !== null && data !== void 0 && data.rows) {
          const table = type === 1 ? auditTableData : auditeeTableData;
          table.value = data === null || data === void 0 ? void 0 : data.rows;

          if (type === 2 && (data === null || data === void 0 ? void 0 : data.rows.length) === 0) {
            // 如果被审核人员未查询到数据 则初始化成 全部人员
            table.value = [{
              businessCategory: '——',
              linkMan: 'ALL',
              loginName: '——',
              salesmanBranchNameCover: '——',
              supUserId: -1,
              supplierId: 150,
              supplierName: '——'
            }];
          }
        }
      });
    }

    watch(() => props.modelValue, newVal => {
      if (newVal && !props.auditMainId) {
        // 非修改 新增数据 重置表格
        auditTableData.value = [];
        auditeeTableData.value = [];
      } else if (newVal && props.auditMainId) {
        // 修改数据时 初始化
        initUpdateData(1);
        initUpdateData(2);
      }
    });

    function add(reviewerType) {
      // 切换表格类型
      reviewer.value = reviewerType;
      showAddSalesmanModal.value = true;
    }

    function del(reviewerType) {
      const table = reviewerType === 1 ? auditTable : auditeeTable;
      const tableData = reviewerType === 1 ? auditTableData : auditeeTableData;
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      } // 将勾选的 过滤


      tableData.value = tableData.value.filter(row => selectRows.every(select => select.supUserId !== row.supUserId));
    }

    function addSuccess(type, selectRows) {
      if (type === 1) {
        // 去重
        auditTableData.value = arrayRemoveRepeatByProp([...auditTableData.value, ...selectRows], 'supUserId');
      } else {
        let firstRow = selectRows[0];
        let currentRow = auditeeTableData.value[0];

        if (firstRow.supUserId === -1 || firstRow.supUserId !== -1 && (currentRow === null || currentRow === void 0 ? void 0 : currentRow.supUserId) === -1) {
          // 如果选择全部 直接替换当前    // 如果之前是全部 现在是自定义 也直接替换
          auditeeTableData.value = selectRows;
          return;
        }

        auditeeTableData.value = arrayRemoveRepeatByProp([...auditeeTableData.value, ...selectRows], 'supUserId');
      }
    }

    function confirm() {
      if (!auditTableData.value.length) {
        ElMessage.warning('审核人不能为空!');
        return;
      }

      if (!auditeeTableData.value.length) {
        ElMessage.warning('被审核人不能为空!');
        return;
      }

      const tableData = [...auditTableData.value, ...auditeeTableData.value];
      const types = auditTableData.value.map(() => 1) + ',' + auditeeTableData.value.map(() => 2);

      const payload = _objectSpread({
        supplierId,
        // 如果被审核人第一项是 -1 是选择的全部
        isAuditAll: auditeeTableData.value[0].supUserId === -1 ? 1 : 0,
        supUserIds: tableData.map(item => item.supUserId).join(',') // 全部不用传supUserId 将占位符清楚
        .replace(',-1', ''),
        types
      }, props.auditParams);

      if (props.auditMainId) {
        payload.auditMainId = props.auditMainId;
      } // 根据 auditMainId 判断是修改还是新增


      const request = props.auditMainId ? updateOrderauditMain : createOrderauditMain;
      request(payload).then(data => {
        if (data.success) {
          ElMessage.success('添加成功!');
          visible.value = false;
          emit('success');
        }
      });
    }

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        title: "人员审核",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _isRef(visible) ? visible.value = $event : null),
        width: "800px"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 1
        })]),
        default: _withCtx(() => [_hoisted_2, _createVNode(_component_vxe_grid, _mergeProps(auditTableOptions, {
          ref_key: "auditTable",
          ref: auditTable,
          data: auditTableData.value
        }), {
          tools: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            icon: "Plus",
            onClick: _cache[0] || (_cache[0] = $event => add(1))
          }, {
            default: _withCtx(() => [_hoisted_3]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "danger",
            icon: "Delete",
            onClick: _cache[1] || (_cache[1] = $event => del(1))
          }, {
            default: _withCtx(() => [_hoisted_4]),
            _: 1
          })]),
          _: 1
        }, 16, ["data"]), _hoisted_5, _createVNode(_component_vxe_grid, _mergeProps(auditeeTableOptions, {
          ref_key: "auditeeTable",
          ref: auditeeTable,
          data: auditeeTableData.value
        }), {
          tools: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            icon: "Plus",
            onClick: _cache[2] || (_cache[2] = $event => add(2))
          }, {
            default: _withCtx(() => [_hoisted_6]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "danger",
            icon: "Delete",
            onClick: _cache[3] || (_cache[3] = $event => del(2))
          }, {
            default: _withCtx(() => [_hoisted_7]),
            _: 1
          })]),
          _: 1
        }, 16, ["data"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(AddSalesmanModal, {
        modelValue: showAddSalesmanModal.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => showAddSalesmanModal.value = $event),
        onSuccess: addSuccess,
        reviewer: reviewer.value,
        supplierId: _unref(supplierId),
        auditParams: __props.auditParams
      }, null, 8, ["modelValue", "reviewer", "supplierId", "auditParams"])]);
    };
  }

};